import React from 'react';
import Icon from '../../../components/AppIcon';

const ChangeHistoryPanel = ({ history }) => {
  if (history?.length === 0) return null;

  return (
    <div className="mt-6 bg-card border border-border rounded-lg shadow-warm p-4">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="History" size={20} color="var(--color-primary)" />
        <h2 className="text-lg font-semibold text-foreground">Historique des modifications</h2>
      </div>
      <div className="space-y-2 max-h-64 overflow-y-auto">
        {history?.map(entry => (
          <div
            key={entry?.id}
            className="flex items-center justify-between py-2 px-3 bg-muted/30 rounded-md text-sm"
          >
            <div className="flex items-center gap-3">
              <Icon name="Edit3" size={14} className="text-muted-foreground" />
              <span className="font-medium text-foreground">{entry?.dishName}</span>
              <span className="text-muted-foreground">•</span>
              <span className="text-muted-foreground">{entry?.field}</span>
            </div>
            <div className="flex items-center gap-3">
              <span className="text-xs text-muted-foreground">{entry?.timestamp}</span>
              <span className="text-xs px-2 py-1 bg-accent/10 text-accent rounded">
                {entry?.action}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ChangeHistoryPanel;